import React from 'react';
import { UniqueIdentifier } from '../../../../../types';
import styles from './ContentList.module.scss';
import {
  useInfiniteScroll,
  UseInfiniteScrollProps,
} from '../../../../../hooks';
import { LoaderWrapper } from '../LoaderWrapper';

export interface ContentListProps<T> {
  items: T[];
  totalPage: number;
  onLoadMore: UseInfiniteScrollProps['fetchMoreData'];
  children: (item: T) => React.ReactNode;
  enableLoadingByScroll: boolean;
}

export function ContentList<T extends { id: UniqueIdentifier }>(
  props: ContentListProps<T>,
) {
  const { items, totalPage, onLoadMore, enableLoadingByScroll, children } =
    props;

  const { containerRef, loading } = useInfiniteScroll<HTMLDivElement>({
    fetchMoreData: onLoadMore,
    totalPage,
    offsetContainerHeight: 300,
    enableScroll: enableLoadingByScroll,
  });

  return (
    <>
      <div className="row" ref={containerRef}>
        {items.map((item, index) => (
          <div key={index} className="col-xs-12 col-sm-6">
            <div className={styles.itemWrapper}>{children(item)}</div>
          </div>
        ))}
      </div>
      <div className={styles.loaderWrapper}>
        <LoaderWrapper loading={loading} />
      </div>
    </>
  );
}
